import Loadable from "react-loadable";

const AsyncArtistExplorePage = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "artist-explore-page" */ "./AsyncArtistExplorePageRoute"
    ),
  loading: () => null,
});

export default AsyncArtistExplorePage;
